import { ApolloError, NetworkStatus } from '@apollo/client'
import { useSetCartId } from '@emico-hooks/cart-id'
import { GraphQLError } from 'graphql'

import { handleCartError } from './handleCartError'

/**
 * @param networkStatus You can optionally pass a networkStatus to check if the request is done.
 * @param skip If this is set to true, no error checking is done
 */
export function useHandleCartError(
  error: ApolloError | GraphQLError | undefined,
  networkStatus?: NetworkStatus,
  skip?: boolean,
) {
  const setCartId = useSetCartId()

  // Don't handle errors of previous requests
  const networkStatusDone =
    networkStatus === NetworkStatus.ready ||
    networkStatus === NetworkStatus.error

  // Sometimes the cart disappears (e.g. because it finished an order in a
  // different tab), in that case we must forget it in our local state.
  if (error && !skip && networkStatusDone) {
    handleCartError(error, setCartId)
  }
}
